// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".yn-modular-menuIcon{width:25px;height:25px;margin-right:5px;border-radius:3px}", ""]);
// Exports
module.exports = exports;
